import { connect } from 'react-redux';
import { ROUTE_CLUB_NEW } from '../constants';
import Component from './component';
import { push } from 'react-router-redux/lib/actions';
import clubAction from '../../../actions/club';
import { CLUB_CMS_PATH } from '../../ClubCMS/constants';
import { getClubsByClubId, getCurrentClubId } from '../../../selectors/club-settings'
import {getClubsConfig} from '../clubsConfig';

export default connect(
  state => {
    const currentClubId = getCurrentClubId(state);
    return {
      ...getClubsConfig(currentClubId),
      loading: state.club.loading,
      items: getClubsByClubId(state.club.items, state),
    }
  },
  (dispatch) => ({
    fetch: () => dispatch(clubAction.fetchList()),
    edit: (item) => dispatch(push(CLUB_CMS_PATH.replace(':id', item.id))),
    add: () => dispatch(push(ROUTE_CLUB_NEW))
  })
)(Component);



// WEBPACK FOOTER //
// ./src/components/Clubs/ClubList/index.js